import moment from 'moment-timezone';
import type React from 'react';
import {
	CancelledCallIcon,
	IncomingCallIcon,
	MissedCallIcon,
	OutGoingCallIcon,
} from 'src/components/job-slide-out/components/nav-table/tenant-lula-chat/icons';
import type { TenantContactMessage } from 'src/types';

export const LumiStatusLabels: Record<string, string> = {
	'in-progress': 'In Progress',
	completed: 'Completed',
	'not-responding': 'Not Responding',
	stopped: 'Stopped',
	'de-escalated': 'De-escalated',
	'not-started': '',
};

// Media when legacy MMS flag is set OR backend flags a media_type.
export const shouldRenderSmsMessageAsMedia = (
	message: Pick<TenantContactMessage, 'mms' | 'media_type'>,
): boolean =>
	!!message?.mms ||
	message?.media_type === 'video' ||
	message?.media_type === 'image';

export const getCallIcon = (
	callType?: TenantContactMessage['call_type'],
	direction?: TenantContactMessage['direction'],
): React.ReactNode => {
	if (callType === 'missed') return <MissedCallIcon />;
	if (callType === 'incoming') return <IncomingCallIcon />;
	if (callType === 'cancelled') return <CancelledCallIcon />;
	if (callType === 'outgoing') return <OutGoingCallIcon />;
	if (direction === 'inbound') return <IncomingCallIcon />;
	if (direction === 'outbound') return <OutGoingCallIcon />;
	return null;
};

export const getCallDuration = (sec: string | number): string => {
	const duration = Number(sec) * 1000;
	let hours: string | undefined;
	let minutes: string | undefined;
	let seconds: string | undefined;
	if (duration / 1000 >= 3600) {
		hours = moment.utc(duration).format('H');
		minutes = moment.utc(duration).format('m');
		seconds = moment.utc(duration).format('s');
	} else if (duration / 1000 >= 60) {
		minutes = moment.utc(duration).format('m');
		seconds = moment.utc(duration).format('s');
	} else {
		seconds = moment.utc(duration).format('s');
	}
	const fHour =
		Number(hours || 0) > 0
			? `${hours} ${Number(hours) === 1 ? 'hour' : 'hours'}`
			: '';
	const fMin = Number(minutes || 0)
		? `${minutes} ${Number(minutes) === 1 ? 'minute' : 'minutes'}`
		: '';
	const fSec = Number(seconds || 0)
		? `${seconds} ${Number(seconds) === 1 ? 'second' : 'seconds'}`
		: '';
	return `${fHour} ${fMin} ${fSec}`.replace(/\s+/g, ' ').trim();
};
